/* ============================================================
   Contact Modal — global JS
   Self-contained: no dependency on other theme JS, and nothing
   else in the theme depends on this file. Safe to add/remove.
   ============================================================ */
(function () {
  if (window.__cmBooted) return;
  window.__cmBooted = true;

  var SS_WIDGET_DISMISSED = 'cm:dismissed';
  var PANEL_GAP = 12; // gap between the floating button and the panel docked above it
  var WORKER_URL = 'https://atv-tek-contact.jj-eb7.workers.dev';

  var GENERAL_INTROS = {
    'Order Help': 'Tell us what\'s going on with your order. We will get back to you within 24-48 hours.',
    'Installation & Product Support': 'Tell us what you\'re running into. We will get back to you within 24-48 hours.',
    'Warranty Claim': 'Tell us the product and what happened, plus your order number if you have it. We\'ll reply by email within 24-48 hours so you can send photos. No registration needed.',
    'Something Else': 'Tell us what\'s going on. We will get back to you within 24-48 hours.'
  };

  // Fires a Klaviyo profile identify + custom event with the submitted
  // fields, independent of whether the actual form submission succeeds, so
  // a Klaviyo flow can trigger on these events and quote the customer's own
  // submission back to them.
  function trackKlaviyo(eventName, email, properties) {
    if (typeof window.klaviyo === 'undefined') return;
    try {
      if (email) window.klaviyo.identify({ email: email });
      window.klaviyo.track(eventName, properties);
    } catch (_) {}
  }

  // IMPORTANT: this must stay strictly non-blocking on the network request
  // itself — Shopify's native contact form has its own invisible CAPTCHA
  // check that can escalate into a disruptive interactive challenge for
  // real visitors, which is exactly why this submits to our own backend
  // (see backend/contact-worker/) via fetch instead. That also lets the
  // panel stay open and show an in-place confirmation rather than a
  // full-page reload. On success this switches to the shared "success"
  // view rather than rewriting the panel body — the body now hosts every
  // view as siblings, so a destructive innerHTML write here would wipe out
  // the menu and every other form for the rest of the session.
  function initFormSubmit(form, showView, eventName) {
    function resetButton(submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send message';
    }

    function showError(message) {
      var existing = form.querySelector('.cm__status--error');
      if (existing) existing.remove();
      var el = document.createElement('div');
      el.className = 'cm__status cm__status--error';
      el.innerHTML = '<p>' + (message || 'Something went wrong sending your message. Please try again, or reach us directly at customerservice@atv-tek.com.') + '</p>';
      form.insertBefore(el, form.firstChild);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitBtn = form.querySelector('.cm__submit');
      if (submitBtn.disabled) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';

      // Wait for the Turnstile token (assets/turnstile-forms.js) so it's in
      // the FormData below; the Worker verifies it.
      var ready = window.ATVTurnstile ? window.ATVTurnstile.waitForToken(form) : Promise.resolve();
      ready.then(function () { send(submitBtn); });
    });

    function send(submitBtn) {
      var payload = Object.fromEntries(new FormData(form).entries());
      var properties = {};
      Object.keys(payload).forEach(function (key) {
        if (key === 'website') return; // honeypot — never sent to Klaviyo
        if (key === 'cf-turnstile-response') return; // anti-spam token — never sent to Klaviyo
        properties[key] = payload[key];
      });
      trackKlaviyo(eventName, payload.email, properties);

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = setTimeout(function () {
        if (controller) controller.abort();
      }, 15000);

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          clearTimeout(timeoutId);
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (response.ok && data.ok) {
              showView('success');
            } else {
              resetButton(submitBtn);
              showError(data.error);
            }
          });
        })
        .catch(function () {
          clearTimeout(timeoutId);
          resetButton(submitBtn);
          showError();
        })
        .then(function () {
          // Tokens are single-use: get a fresh one for any next submission.
          if (window.ATVTurnstile) window.ATVTurnstile.reset(form);
        });
    }
  }

  function initWidgetDismiss() {
    var widget = document.querySelector('[data-cm-widget]');
    var dismissBtn = document.querySelector('[data-cm-dismiss]');
    if (!widget || !dismissBtn) return;

    dismissBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // don't let this bubble into the trigger button below it
      widget.hidden = true;
      try { sessionStorage.setItem(SS_WIDGET_DISMISSED, '1'); } catch (_) {}
    });
  }

  function layout(widget, panel) {
    // Shopify's own theme-preview bar (shown to anyone currently in a theme
    // preview session) is fixed to the bottom of the viewport and would
    // otherwise sit on top of this widget, intercepting its clicks.
    var bar = document.getElementById('PBarNextFrameWrapper');
    widget.style.bottom = bar ? (bar.getBoundingClientRect().height + 20) + 'px' : '';

    // Dock the panel directly above the button, wherever it ends up, and
    // cap its height to the space actually available above it — on short
    // viewports the CSS max-height alone isn't enough to keep it from
    // running off the top of the screen.
    var wr = widget.getBoundingClientRect();
    panel.style.bottom = (window.innerHeight - wr.top + PANEL_GAP) + 'px';
    panel.style.left = wr.left + 'px';
    panel.style.maxHeight = Math.max(200, wr.top - PANEL_GAP - 12) + 'px';
  }

  // Handles switching between the triage menu and its sub-views (order
  // help, build-my-setup form, general form), including updating the
  // general form's category + heading whenever a menu item routes there.
  function initViews(root, body) {
    var views = root.querySelectorAll('[data-cm-view]');
    var generalCategoryInput = root.querySelector('[data-cm-general-category]');
    var generalHeading = root.querySelector('[data-cm-general-heading]');
    var generalIntro = root.querySelector('[data-cm-general-intro]');
    var installLink = root.querySelector('[data-cm-install-link]');

    function showView(name) {
      views.forEach(function (v) { v.hidden = v.dataset.cmView !== name; });
      body.scrollTop = 0;
      var target = root.querySelector('[data-cm-view="' + name + '"]');
      var firstField = target && target.querySelector('input, textarea, select, button');
      if (firstField) firstField.focus();
    }

    root.addEventListener('click', function (e) {
      var goto = e.target.closest && e.target.closest('[data-cm-goto]');
      if (goto) {
        e.preventDefault();
        var target = goto.dataset.cmGoto;
        var category = goto.dataset.cmCategory;
        if (target === 'general' && category) {
          if (generalCategoryInput) generalCategoryInput.value = category;
          if (generalHeading) generalHeading.textContent = category;
          if (generalIntro) generalIntro.textContent = GENERAL_INTROS[category] || GENERAL_INTROS['Something Else'];
          if (installLink) installLink.hidden = category !== 'Installation & Product Support';
        }
        showView(target);
        return;
      }
      var back = e.target.closest && e.target.closest('[data-cm-back]');
      if (back) {
        e.preventDefault();
        showView('menu');
      }
    });

    return showView;
  }

  function init() {
    initWidgetDismiss();

    var widget = document.querySelector('[data-cm-widget]');
    var trigger = document.querySelector('[data-cm-trigger]');
    var root = document.querySelector('[data-cm-root]');
    var body = root && root.querySelector('[data-cm-panel-body]');
    if (!widget || !trigger || !root || !body) return;

    layout(widget, root);
    window.addEventListener('resize', function () { layout(widget, root); });

    var closeEls = root.querySelectorAll('[data-cm-close]');
    var lastFocused = null;
    var showView = initViews(root, body);

    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    function onDocumentClick(e) {
      if (root.contains(e.target) || trigger.contains(e.target)) return;
      close();
    }

    function open() {
      layout(widget, root);
      lastFocused = document.activeElement;
      root.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
      showView('menu'); // always open back at the triage menu, and handles focus
      document.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onDocumentClick, true);
    }

    function close() {
      root.classList.remove('is-visible');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('click', onDocumentClick, true);
      setTimeout(function () {
        root.hidden = true;
      }, 200);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (root.hidden) {
        open();
      } else {
        close();
      }
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    var buildForm = root.querySelector('[data-cm-form="build"]');
    var generalForm = root.querySelector('[data-cm-form="general"]');
    if (buildForm) initFormSubmit(buildForm, showView, 'Requested Personalized Help');
    if (generalForm) initFormSubmit(generalForm, showView, 'Contacted Support');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
